module.exports = __webpack_public_path__ + "static/media/pawprint.4bc4f401.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/pawprint.svg
// module id = 489
// module chunks = 0